import SaleUtils from '@/services/SaleUtils'
//
export default [
  {
      text: "nombre",
      value: "name",
  },
  {
      text: "Codigo Interno",
      value: "internal_code",
  },
  // {
  //     text: "Precio Compra",
  //     value: "cost_price",
  //     format: "currency",
  //     align: "right",
  //     input: {
  //         reverse: true,
  //         type: "currency-field",
  //         trigger:(ctx,props) =>{
  //           props.item.gains_margin = SaleUtils.getNewMargin(props.item.sale_price,props.item.cost_price)
  //         }
  //     },
  // },
  // {
  //   text: "Precio Venta",
  //   value: "sale_price",
  //   format: "currency",
  //   align: "right",
  //   input: {
  //     reverse: true,
  //     type: "currency-field",
  //     trigger:(ctx,props) =>{
  //       props.item.gains_margin = SaleUtils.getNewMargin(props.item.sale_price,props.item.cost_price)
  //     }
  //   },
  // },
  {
    text: "Cantidad",
    value: "quantity",
    align: "right",
    input: {
      reverse: true,
      //type: "text-field"
    },
  },
  // {
  //     text: "stock critico",
  //     value: "critical_stock",
  //     align: "right",
  //     input: {
  //         reverse: true,
  //         type: "text-field"
  //     },
  // },
]